import "bootstrap/dist/css/bootstrap.css";
import "./setupDayjs";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import "../src/assets/styles/scss/app.scss";
import App from "./App";
import LoadingComponent from "./app/components/loading";
import { persistor, store } from "./app/store";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
ReactDOM.render(
  <React.Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LoadingComponent />
        <App  />
        <ToastContainer />
      </PersistGate>
    </Provider>
  </React.Fragment>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
